export default "__VITE_PUBLIC_ASSET__51825b30__"